// hooks/useIsMobileOrTablet.js
import { useState, useEffect } from 'react';

export const useIsMobileOrTablet = () => {
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileOrTablet(window.innerWidth <= 1023);
    };

    // Vérifier au chargement
    checkScreenSize();

    // Écouter les changements de taille
    window.addEventListener('resize', checkScreenSize);

    // Nettoyage
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobileOrTablet;
};